/* eslint-disable prefer-const */
/*
 * @Author: edvardchen
 * @Date: 2017-11-08 17:26:02
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2021-09-06 16:16:58
 */

// @flow
import _ from 'lodash';
import { stringify, parse } from 'query-string';
import { listen } from 'fbjs/lib/EventListener';
import { isAndroid } from '@tencent/qb-article-util/lib/UA';
import { type AllComments, type Dispatch, type GetState, type Comment, type PostInfo } from '../types';
import { circle } from '../../fetchers/';
// import { listenToPostMessageReady } from '../../entries/RN-postMessage';
import { makeInsertFakeComment, makeTweetSuccess, makeDelFakeComment } from './tweetAction';
import { checkLogin } from '../user';

import {
  localStorage,
  isomorphicConfig,
  supportPopCommentQbUrl,
  redirect,
  track,
  supportNestedComments,
  getBusinessType,
  isQiGeUrl,
  commentExpWhiteList,
  isHippy,
  postMessage,
} from '../../utility';
import { getQIMEI36 } from '../../utility/C4PV';

declare var __CLIENT__: boolean;

export const ADD_HOT = 'comment/ADD_HOT';
export const HIDE_OPTIONS = 'comment/HIDE_OPTIONS'; // hide option popup of all comments
export const SHOW_OPTIONS = 'comment/SHOW_OPTIONS';
export const MORE_FETCH_START = 'comment/MORE_FETCH_START';
export const MORE_FETCH_FAIL = 'comment/MORE_FETCH_FAIL';
export const MORE_FETCH_SUCCESS = 'comment/MORE_FETCH_SUCCESS';
export const RESET_ALLCOMMENTS = 'comment/RESET_ALLCOMMENTS';
export const RESET_HOTCOMMENTS = 'comment/RESET_HOTCOMMENTS';
export const SET_HOTCOMMENT = 'comment/SET_HOTCOMMENT';

export const RESET_POST = 'comment/RESET_POST';
export const UPDATE_POST = 'comment/UPDATE_POST';
export const PRAISE_COMMENT = 'comment/PRAISE';
export const PRAISE_POST = 'comment/PRAISE_POST';
export const CANCEL_PRAISE_POST = 'comment/CANCEL_PRAISE_POST';

export const RESET_COMMENT = 'comment-detail/RESET_COMMENT';
export const RESTOTHERFTSTATE = 'resetOtherFtState';
export const ENABLE_NESTED_COMMENTS = 'comment/ENABLE_NESTED_COMMENTS';
export const DISABLE_NESTED_COMMENTS = 'comment/DISABLE_NESTED_COMMENTS';

export const RESET_USER_HONORS = 'comment/RESET_USER_HONORS';

export * from './tweetAction';

export const enableNestedComments = () => ({ type: ENABLE_NESTED_COMMENTS });
export const disableNestedComments = () => ({ type: DISABLE_NESTED_COMMENTS });

// private
const hideOptions = () => ({ type: HIDE_OPTIONS });

let optionsListener;
const DELAY = 300;
export const hideCommentOptions = () => async (dispatch: Dispatch) => {
  optionsListener && optionsListener.remove();
  optionsListener = undefined;
  dispatch(hideOptions());
};

export const showCommentOptions = (comment: Comment) => async (dispatch: Dispatch) => {
  dispatch(hideOptions());
  dispatch({ payload: comment, type: SHOW_OPTIONS });
  if (__CLIENT__ && !optionsListener) {
    optionsListener = listen(
      document.body,
      'touchmove',
      _.throttle(() => {
        dispatch(hideOptions());
        optionsListener && optionsListener.remove();
        optionsListener = undefined;
      }, DELAY),
    );
  }
};

export const SHOW_CONFIRM_MODAL = 'comment/SHOW_CONFIRM_MODAL';
export const showConfirmModal = (payload: *) => ({ type: SHOW_CONFIRM_MODAL, payload });
export const CLOSE_CONFIRM_MODAL = 'comment/CLOSE_CONFIRM_MODAL';
export const closeConfirmModal = () => ({ type: CLOSE_CONFIRM_MODAL });

export const SHOW_COMMENT_SHARE_MODAL = 'comment/SHOW_COMMENT_SHARE_MODAL';
export const showCommentShareModal = (payload: *) => ({ type: SHOW_COMMENT_SHARE_MODAL, payload });
export const CLOSE_COMMENT_SHARE_MODAL = 'comment/CLOSE_COMMENT_SHARE_MODAL';
export const closeCommentShareModal = () => ({ type: CLOSE_COMMENT_SHARE_MODAL });

export const SHOW_ACCUSE_MODAL = 'comment/SHOW_ACCUSE_MODAL';
export const showAccuseModal = (payload: *) => ({ type: SHOW_ACCUSE_MODAL, payload });
export const CLOSE_ACCUSE_MODAL = 'comment/CLOSE_ACCUSE_MODAL';
export const closeAccuseModal = () => ({ type: CLOSE_ACCUSE_MODAL });

export const resetAllComments = (payload: AllComments) => ({ type: RESET_ALLCOMMENTS, payload });
export const resetHotComments = (payload: Comment[]) => ({ type: RESET_HOTCOMMENTS, payload });

export const addHotComments = (payload: mixed) => ({ type: ADD_HOT, payload });

export const loadMoreComment = () => ({ type: MORE_FETCH_START });

export const loadMoreCommentFailed = (payload: Object) => ({ type: MORE_FETCH_FAIL, payload });

export const loadMoreCommentSuccess = (payload: Object) => ({ type: MORE_FETCH_SUCCESS, payload });

export const resetPost = (payload: PostInfo) => ({ type: RESET_POST, payload });

export const updatePost = (payload: Object) => ({ type: UPDATE_POST, payload });

export const praiseComment = (payload: *) => ({ type: PRAISE_COMMENT, payload });

export const praisePost = (payload: { id: string }) => ({ type: PRAISE_POST, payload });

export const cancelPraisePost = (payload: { id: string }) => ({ type: CANCEL_PRAISE_POST, payload });

export const resetComment = (payload: Comment) => ({ type: RESET_COMMENT, payload });
export const resetOtherFtState = (payload: boolean) => ({ type: RESTOTHERFTSTATE, payload });

const resetUserHonors = (payload: *) => ({ type: RESET_USER_HONORS, payload });

export const RESET_OPERATE_BAR = 'comment/RESET_OPERATE_BAR';
export const resetOperateBar = (payload: *) => ({ type: RESET_OPERATE_BAR, payload });

const COMMENT_KEY = 'qb_commentpraises';
const POST_KEY = 'qb_postpraises';

export const COMMENT_DEL_KEY = 'qb_del_commentid';

const updateOldPraisedData = (id, cacheKey, isLike) => {
  let old = localStorage.getItem(cacheKey) || [];
  if (isLike) {
    old.push(id);
  } else {
    old = old.filter((docid) => id !== docid);
  }
  localStorage.setItem(cacheKey, old);
};
type T = 'post' | 'comment';
export const injectPraisesFromCache = (arrList: *[], type: T = 'comment') => {
  let key;
  const list = arrList || [];
  switch (type) {
    case 'comment':
      key = COMMENT_KEY;
      break;
    case 'post':
      key = POST_KEY;
      break;
    default:
      return list;
  }
  const old = localStorage.getItem(key) || [];
  if (!old.length) {
    return list;
  }
  return list.map((item) => {
    if (old.indexOf(item.id) > -1) {
      return {
        ...item,
        praised: true,
        praiseNum: item.praiseNum,
      };
    }
    return item;
  });
};

export const makeDelComment = ({ id, circleId }: { id: string, circleId: string }) => async (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const {
    postInfo: { postId },
    allComments: { items: commentList },
    allComments,
    hotComments,
  } = getState();
  const ret = await circle
    .delComment({
      circleId,
      postId,
      commentId: id,
    })
    .catch((e) => e);

  const toast = _.get(window, 'browser.app.toast');
  // -414是后台已经删除了
  if (
    !ret ||
    (ret instanceof Error && ret.body && ret.body.code !== -414) ||
    (typeof ret.iRtnCode === 'number' && ret.iRtnCode !== 0)
  ) {
    toast && toast(`删除失败(${(ret.body && ret.body.code) || ret.iRtnCode || -1000})`);
    return -1;
  }

  toast && toast('删除成功');
  const hotCom = hotComments.filter((item) => item.id !== id);
  const allCom = commentList.filter((item) => item.id !== id);
  const all = Object.assign({}, allComments);
  all.items = allCom;
  dispatch(resetHotComments(hotCom));
  dispatch(resetAllComments(all));
  dispatch(makeDelFakeComment(id));

  localStorage.setItem(COMMENT_DEL_KEY, id);
  return 0;
};

export const makeSetHotComment = ({
  id,
  circleId,
  bNicePost,
}: {
  id: string,
  circleId: string,
  bNicePost: boolean,
}) => async (dispatch: Dispatch, getState: GetState) => {
  const {
    postInfo: { postId },
    allComments: { items: commentList },
    hotComments,
    allComments,
  } = getState();
  const manageType = bNicePost ? 0 : 1; // 1 表示设置精华操作.0 表示取消精华操作.
  const ret = await circle.setNicePost({
    circleId,
    postId,
    commentId: id,
    manageType,
  });

  const toast = _.get(window, 'browser.app.toast');
  if (ret && ret.code) {
    toast && toast(`操作失败(${ret.code})`);
    return;
  }

  toast && toast('操作成功');
  function pullOut(list) {
    let curComment = null;
    const newCommentList = _.reject(list, (item) => {
      const eq = item.id === id;
      if (eq) {
        curComment = item;
      }
      return eq;
    });
    return [newCommentList, curComment];
  }
  if (manageType) {
    // 设置精华
    const [newCommentList, curComment] = pullOut(commentList);
    if (curComment) {
      dispatch(addHotComments(Object.assign({}, curComment, { showOptions: false, bNicePost: manageType })));
      dispatch(resetAllComments(Object.assign({}, allComments, { items: newCommentList })));
    }
  } else {
    // 取消精华
    const [newCommentList, curComment] = pullOut(hotComments);
    dispatch(resetHotComments(newCommentList));
    if (curComment) {
      dispatch(
        resetAllComments(
          Object.assign({}, allComments, {
            items: Array.isArray(commentList) ? [curComment, ...commentList] : [curComment],
          }),
        ),
      );
    }
  }
  dispatch(hideCommentOptions());
};

export const makeFetchUserHonorInfoEx = ({ users }: { users: *[] }) => async (
  dispatch: Dispatch,
  getState: GetState,
) => {
  if (!__CLIENT__) {
    return;
  }
  if (!users || !users.length) {
    return;
  }
  const result = await circle.getUserHonorInfoEx({ users });
  const { honorInfoEx = {} } = getState();

  const newHonorInfoEx = Object.assign({}, honorInfoEx);
  _.mergeWith(newHonorInfoEx, result || {}, (objValue, srcValue) => Object.assign({}, objValue, srcValue));
  dispatch(resetUserHonors(newHonorInfoEx));

  let medalCount = 0;
  let identCount = 0;
  let kolIdentCount = 0;

  if (result && result.honorInfos) {
    _.mapValues(result.honorInfos, (honorItems) => {
      // const honor = honorItems.vHonorItem && honorItems.vHonorItem[0];
      const honor = [];
      const generalCertifiedAry = [];
      honorItems.vHonorItem &&
        honorItems.vHonorItem.filter((item) => {
          if (item.isMedal) {
            honor.push(item);
          } else if (item.eType === 2 || item.eType === 3) {
            generalCertifiedAry.push(item);
          }
          return null;
        });
      /* eslint-disable no-plusplus */
      honor && honor[0] && honor[0].isMedal && medalCount++;
      generalCertifiedAry && generalCertifiedAry[0] && identCount++;
      return honorItems;
    });
    _.mapValues(result.kolInfos, (kolInfoItem) => {
      kolInfoItem && kolInfoItem.isCertified && kolIdentCount++;
      return kolInfoItem;
    });

    medalCount &&
      track({
        location: 'comment',
        object: 'medal',
        action: 'expose',
        ext: medalCount,
        ch: '600004',
      });

    identCount &&
      track({
        location: 'comment',
        object: 'ident_avatar_normal',
        action: 'expose',
        ext: identCount,
        ch: '600004',
      });

    kolIdentCount &&
      track({
        location: 'comment',
        object: 'ident_avatar_kol',
        action: 'expose',
        ext: kolIdentCount,
        ch: '600004',
      });
  }
};

export const makeShowAccuseModal = (props) => async (dispatch: Dispatch) => {
  dispatch(checkLogin({ doLogin: true })).then((succ) => {
    if (succ) {
      dispatch(showAccuseModal(props));
    }
  });
};
// 抽取首层和次层评论的用户，并去重
function extractUser(comments) {
  // 抽取首层和次层评论的用户，并去重
  const userIdSet = {};
  const users = [];
  const extraUser = (comment) => {
    const user = comment.user || {};
    if (!userIdSet[user.id]) {
      userIdSet[user.id] = true;
      users.push({ eAccountType: user.accountType || 0, sUserId: user.id });
    }
  };
  comments.forEach((comment) => {
    extraUser(comment);
    const { subComments } = comment;
    if (subComments && subComments.items && Array.isArray(subComments.items)) {
      subComments.items.forEach((subComment) => {
        extraUser(subComment);
      });
    }
  });
  return users;
}
export const makeFetchHotComments = ({
  postId: _postId,
  niceComment,
}: { postId?: string, niceComment?: boolean } = {}) => async (dispatch: Dispatch, getState: GetState) => {
  const {
    postInfo: { postId, circleId },
    showNestedComments,
  } = getState();

  const params: { postId: string, circleId: string, niceComment?: boolean } = {
    postId: _postId || postId,
    circleId,
  };
  if (niceComment) {
    // 【评论页“热评区”改“编辑精选”区】http://tapd.oa.com/quan/prong/stories/view/1010092171063624425
    params.niceComment = true;
  }

  let comments = await circle[showNestedComments ? 'getHotComment$NEW' : 'getHotComment'](params);

  if (__CLIENT__) {
    comments = injectPraisesFromCache(comments);
  }
  dispatch(addHotComments(comments));
  const users = extractUser(comments);
  dispatch(makeFetchUserHonorInfoEx({ users }));
};

export const makeFetchMoreComment = (
  params: { postId?: string, circleId?: string, isVideo?: boolean, direction?: number } = {},
) => async (dispatch: Dispatch, getState: GetState) => {
  let {
    postInfo: { postId, circleId, valid },
    showNestedComments,
    allComments: { fetchStatus, lastId, lastTime: startTime, position, isVideo, lastIndex: startIndex },
  } = getState();

  if (!valid) {
    console.warn('已经关闭评论');
    return;
  }
  const isvideo = isVideo || params.isVideo;
  postId = params.postId || postId;
  circleId = params.circleId || circleId;
  if (!postId || !circleId) {
    console.error('circleId/posId not found', circleId, postId);
    return;
  }
  if (fetchStatus === 'fetching') {
    return;
  }
  dispatch(loadMoreComment());

  const reqData = {
    postId,
    circleId,
    lastId,
    startTime,
    position,
    direction: params.direction || 5, // 这里默认改为热门序
    startIndex,
  };
  try {
    const result = await circle[showNestedComments ? 'getNewComment$NEW' : 'getNewComment'](reqData);
    if (typeof result === 'object') {
      result.isVideo = isvideo;
    }
    if (__CLIENT__) {
      result.items = injectPraisesFromCache(result.items);
    }
    dispatch(loadMoreCommentSuccess(result));
    dispatch(makeInsertFakeComment());

    const users = extractUser(result.items);
    dispatch(makeFetchUserHonorInfoEx({ users }));
  } catch (e) {
    dispatch(loadMoreCommentFailed(e));
  }
};

export const makePraiseComment = ({ id, images }: { id: string, images: [] }) => async (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const praised = (localStorage.getItem(COMMENT_KEY) || []).indexOf(id) > -1;
  if (praised) {
    dispatch(
      praiseComment({
        id,
      }),
    );
    return;
  }
  const {
    postInfo: { circleId, postId },
    grayConfig = {},
  } = getState();
  dispatch(praiseComment({ id }));
  await circle.praise({ id, circleId, postId });

  updateOldPraisedData(id, COMMENT_KEY);
  const loc = getBusinessType();
  const whiteList = commentExpWhiteList();
  track({
    location: loc,
    object: 'comment_like',
    action: 'click',
    whiteList,
    grayConfig,
  });

  const picUrl = _.get(images, '[0].sPicUrl');
  // 屏蔽器哥表情
  if (picUrl && !isQiGeUrl(picUrl)) {
    track({
      location: loc,
      object: 'comment_pic_like',
      action: 'click',
      whiteList,
      grayConfig,
    });
  }
};

export const makePraisePost = (data: {
  circleId: string,
  id: string,
  isLike: boolean,
  ext?: Object,
  isCheckLogin: boolean,
}) => async (dispatch: Dispatch) => {
  const praised = (localStorage.getItem(POST_KEY) || []).indexOf(data.id) > -1;
  if (data.isLike) {
    dispatch(praisePost(data));
  } else {
    dispatch(cancelPraisePost(data));
  }
  if (praised === data.isLike && !data.isCheckLogin) {
    // 更新态与本地存储一致时，不请求接口
    return;
  }
  const handle = _.get(window, 'browser.device.getTuringTicket');
  const qimei36 = await getQIMEI36();
  if (handle) {
    handle(
      async (turingTicket) => {
        let extInfo = `${data.ext?.extInfo}&turingTicket=${turingTicket?.turingTicket}&qimei36=${qimei36}&busiType=article}`;
        const ext = { extInfo };
        const _data = { ...data, ext };
        // 支持取消点赞
        await circle.praisePost(_data);
        updateOldPraisedData(_data.id, POST_KEY, _data.isLike);
      },
      async () => {
        await circle.praisePost(data);
        updateOldPraisedData(data.id, POST_KEY, data.isLike);
      },
    );
  } else {
    await circle.praisePost(data);
    updateOldPraisedData(data.id, POST_KEY, data.isLike);
  }
};

const setPraiseInfo = () => {
  // listenToPostMessageReady(() => {
  postMessage({
    func: 'coolread.setPraiseInfo',
    data: { praised: true, isClick: false },
  });
  // });
};

export const makeReadPraisesCached = () => async (dispatch: Dispatch, getState: GetState) => {
  const {
    postInfo: { postId },
    hotComments = [],
    comment,
    location: { query },
  } = getState();

  const posts = localStorage.getItem(POST_KEY) || [];
  if (posts.indexOf(postId) > -1) {
    dispatch(praisePost({ id: postId }));
    setPraiseInfo();
  } else if (query && query.nExt) {
    try {
      const { isPraised } = JSON.parse(query.nExt) || {};
      if (isPraised === 1) {
        dispatch(praisePost({ id: postId }));
        updateOldPraisedData(postId, POST_KEY);
      }
    } catch (e) {
      console.log(e);
    }
  }

  const comments = localStorage.getItem(COMMENT_KEY) || [];
  [...hotComments, comment].filter(Boolean).forEach(({ id }) => {
    if (comments.indexOf(id) > -1) {
      dispatch(praiseComment({ id, praised: true }));
    }
  });
};

function syncCommentNum({ docId, commentNum }) {
  const sendMsgToFeeds = _.get(window, 'browser.coolread.sendMsgToFeeds');
  if (sendMsgToFeeds) {
    // 1表示资讯正文对应的businessId
    sendMsgToFeeds({ type: 'SYNC_COMMENT_NUM', ItemId: `1_${docId}`, num: commentNum });
  }
}
const postMsg4CommentNum = (data: Object) => {
  if (isHippy()) {
    postMessage(
      JSON.stringify({
        func: 'coolread.setCommentInfo',
        data,
      }),
    );
    Object.keys(data).forEach((key) => {
      console.debug(`====postMsg4CommentNum====${key}`, data[key]);
    });
  }
};
/**
 * 通知终端相关的评论信息
 */
export const makeNotifyPostToNative = () => async (dispatch: Dispatch, getState: GetState) => {
  const {
    article: { docId },
    postInfo: { circleId, isVideo, postId, commentUrl = '', commentNum = 0, praised = false },
    comment,
  } = getState();
  const setPostInfo = _.get(window, 'browser.coolread.setPostInfo');
  const ch = _.get(isomorphicConfig, 'circle.ch_setpostinfo');
  const chVideo = _.get(isomorphicConfig, 'circle.ch_setpostinfo_video');
  let params = {
    circleId,
    postId,
    ch: isVideo ? chVideo : ch,
    praised,
  };
  if (comment) {
    // 二级评论页面
    params = {
      ...params,
      parentCommentId: comment.id,
    };
  }
  console.log('====setPostInfo====', params);
  setPostInfo && setPostInfo(params);
  if (commentNum && commentNum > 0) {
    // const setCommentInfo = _.get(window, 'browser.coolread.setCommentInfo');
    const commentNumStr = String(commentNum);
    syncCommentNum({ docId, commentNum: commentNumStr });
    // console.log('====setCommentInfo====', commentNum, commentUrl);
    postMsg4CommentNum({
      cmtNum: commentNumStr,
      cmtUrl: commentUrl || '',
    });
    window._commentNum_ = commentNum;
  }
};

export const makeAddCommentNum = () => async (dispatch: Dispatch, getState: GetState) => {
  const {
    postInfo: { commentNum, commentUrl },
    article: { docId, from },
  } = getState();
  // const setCommentInfo = _.get(window, 'browser.coolread.setCommentInfo');
  const newCommentNum = String(commentNum + 1);
  syncCommentNum({ docId, commentNum: newCommentNum });
  postMsg4CommentNum({
    toFeeds: `${from} ${newCommentNum}评`,
    cmtNum: newCommentNum,
    cmtUrl: commentUrl || '',
  });
  dispatch(updatePost({ commentNum: newCommentNum }));
};

export const makeUpdateCommentNum = (iCommentNum = 0) => async (dispatch: Dispatch, getState: GetState) => {
  const {
    postInfo: { commentUrl },
    article: { docId, from },
  } = getState();
  // const setCommentInfo = _.get(window, 'browser.coolread.setCommentInfo');
  const iCommentNumStr = String(iCommentNum);
  syncCommentNum({ docId, commentNum: iCommentNumStr });
  postMsg4CommentNum({
    toFeeds: `${from} ${iCommentNum}评`,
    cmtNum: iCommentNumStr,
    cmtUrl: commentUrl || '',
  });
  dispatch(updatePost({ commentNum: iCommentNum }));
};

export const makeGetVote = () => async (dispatch: Dispatch, getState: GetState) => {
  const {
    postInfo: { pkId },
  } = getState();
  if (pkId) {
    const result = await circle.getVote({ postId: pkId });
    dispatch(updatePost({ vote: result }));
  }
};

export const makeVote = (idx: number) => async (dispatch: Dispatch, getState: GetState) => {
  if (!__CLIENT__) {
    return;
  }
  const {
    postInfo: { vote },
  } = getState();
  if (!vote) {
    return;
  }
  const { sCircleId, postId } = vote;
  const result = await circle.vote({
    postId,
    idx,
    circleId: sCircleId,
  });

  dispatch(updatePost({ vote: result }));
};

/**
 * 打开二级评论页面（暂态页面）
 */
export const makeOpenComment = (props: Object) => async (dispatch: Dispatch, getState: GetState) => {
  if (!__CLIENT__) {
    return;
  }
  const {
    postInfo: { isDarkComments, isVideo, circleId },
    location: reduxLocation = {},
    grayConfig = {},
    article: { docId },
  } = getState();
  const {
    location: { origin, protocol },
  } = window;
  const targetOrigin = isomorphicConfig.newsHost ? `${protocol}${isomorphicConfig.newsHost}` : origin;
  const extInfo = _.get(reduxLocation, 'query.extInfo');
  const urlParams = stringify({
    circleId,
    dark: isDarkComments,
    extInfo,
    docId,
  });
  let queryId = '';
  const url = `${targetOrigin}${isVideo ? '/video' : ''}/comments/${props.id}?${urlParams}`;
  const extenddata = _.get(reduxLocation, 'query.extenddata');
  if (extenddata) {
    const extData = parse(extenddata) || {};
    queryId = extData.queryId || '';
  }
  const isLoginPraise = grayConfig.commentLogNoPraise && grayConfig.commentLogNoPraise.isAble ? 0 : 1;
  const params = {
    url,
    tips: `回复 ${props.user.name}:`,
    queryId,
    isLoginPraise,
    docId,
    extInfo: `queryId=${queryId}&pid=${_.get(reduxLocation, 'query.pid', '')}`,
  };
  const handle = _.get(window, 'browser.coolread.openCommentPage');
  // 视频评论不支持qb地址
  if (!isVideo && supportPopCommentQbUrl(_.get(window, 'browser.env.version'))) {
    let isOpenCommentPage = false;
    try {
      isOpenCommentPage = window.location.search.match('open-comment-type=commentpage');
    } catch (e) {
      isOpenCommentPage = false;
      console.log('error', e);
    }
    if (isOpenCommentPage) {
      console.log(
        `qb://ext/rn?module=commentpage&component=commentpage&coverToolbar=true&orientation=1&use_comment=1&from=info-content&innerId=${props.id}`,
      );
      redirect(
        `qb://ext/rn?module=commentpage&component=commentpage&coverToolbar=true&orientation=1&use_comment=1&from=info-content&innerId=${props.id}`,
      );
    } else {
      redirect(`qb://ext/read?popcomment&${stringify(params)}`);
    }
  } else if (handle) {
    handle(params);
  } else {
    redirect(url);
  }
};

export const makeFollowPerson = ({ userId, accountType }: { userId: string, accountType: number }) => async (
  dispatch: Dispatch,
  getState: GetState,
) => {
  if (!__CLIENT__) {
    return;
  }
  const result = await circle.followPerson({ userId, accountType }).catch((err) => {
    console.log(err);
    return { code: -1 };
  });

  if (result && (result.code === 0 || result.code === 1)) {
    const { honorInfoEx = {} } = getState();
    const newHonorInfoEx = Object.assign({}, honorInfoEx);
    _.set(newHonorInfoEx, `kolInfos.${accountType}_${userId}.followed`, true);
    dispatch(resetUserHonors(newHonorInfoEx));
  }
  return result;
};

export const makeUnFollowPerson = ({ userId, accountType }: { userId: string, accountType: number }) => async (
  dispatch: Dispatch,
  getState: GetState,
) => {
  if (!__CLIENT__) {
    return;
  }
  const result = await circle.unFollowPerson({ userId, accountType }).catch((err) => {
    console.log(err);
    return { code: -1 };
  });

  if (result && result.code === 0) {
    const { honorInfoEx = {} } = getState();
    const newHonorInfoEx = Object.assign({}, honorInfoEx);
    _.set(newHonorInfoEx, `kolInfos.${accountType}_${userId}.followed`, false);
    dispatch(resetUserHonors(newHonorInfoEx));
  }
  return result;
};

let canShowCommentPanel = true;

export const makeShowCommentPanel = () => async (dispatch: Dispatch, getState: GetState) => {
  if (!__CLIENT__) {
    return;
  }
  // 防止连续调起评论框，这里做一个控制
  if (!canShowCommentPanel) return;
  canShowCommentPanel = false;
  setTimeout(() => {
    canShowCommentPanel = true;
  }, 1000);

  const { comment } = getState();
  setTimeout(() => {
    if (comment && comment.commentNum <= 0 && supportNestedComments(_.get(global, 'browser.env.version'))) {
      const name = _.get(comment, 'user.name') || '';
      const placeholder = `回复 ${name}`;
      const data = {
        parentCommentId: comment.id,
        placeholder,
      };

      const handle = _.get(global, 'browser.coolread.openCommentPanel');
      console.log('====autoOpenCommentPanel====', data);
      handle && handle(data);
    }
  }, 400);
};

export const setOtherFtState = (isOtherFt?: boolean = false) => async (dispatch: Dispatch) => {
  dispatch(resetOtherFtState(isOtherFt));
};

export const makeSendShareComment = () => async (dispatch: Dispatch, getState: GetState) => {
  if (!__CLIENT__) {
    return;
  }

  const {
    postInfo: { circleId, postId },
    comment,
  } = getState();
  const result = await circle.writeComment({
    sText: '转发了',
    circleId,
    postId,
    parentCommentId: (comment && comment.id) || '',
  });

  console.log('makeSendShareComment', result);
  if (result && result.id && result.jsonData) {
    dispatch(makeTweetSuccess(JSON.parse(result.jsonData), { manualScroll: true }));
  }
};

export const makeCommentShare = ({ platform, url }: { platform: number, url: string }) => async (
  dispatch: Dispatch,
) => {
  if (!__CLIENT__) {
    return;
  }
  const share = _.get(window, 'browser.app.share');
  const options = {
    img_data: url,
    file_type: isAndroid(window.navigator.userAgent) ? 1 : undefined,
    to_app: platform,
  };

  window.dispatch = dispatch;
  window.makeSendShareComment = makeSendShareComment;

  share &&
    share(options, (opt) => {
      /* eslint-disable eqeqeq */
      if (opt && (opt.code == 1 || opt.result == 0)) {
        window.dispatch(window.makeSendShareComment());
      }
      window.dispatch = null;
      window.makeSendShareComment = null;
    });
  dispatch(closeCommentShareModal());
};

export const makeFetchOperateMsgs = () => async (dispatch: Dispatch, getState: GetState) => {
  if (!__CLIENT__) {
    return;
  }
  const {
    allComments: { items: commentList },
    hotComments,
    operateMsgs,
    postInfo: { commentNum = 0 },
  } = getState();
  // 0评不拉取运营位数据
  if (!commentList || !commentList.length || commentNum < 3 || operateMsgs) return;

  const result = await circle.getOprMsgs().catch((err) => {
    console.log('getOprMsgs err:', err);
    return null;
  });

  if (result) {
    hotComments && hotComments.length && (result.showInHot = true);
    dispatch(resetOperateBar(result));
  }
};
